import { call, put, takeLatest } from "redux-saga/effects";
import request from "utils/request";
import { emailApprovalActions } from ".";

/**
 * GET USER DETAILS
 */
function* fetchUserApprovalSaga(action) {
  try {
    const { id_hash, params } = action.payload;

    let queryParam = "";

    if (id_hash) {
      queryParam = `id_hash=${encodeURIComponent(id_hash)}`;
    } else if (params) {
      queryParam = `params=${encodeURIComponent(params)}`;
    } else {
      throw new Error("Missing id_hash or params");
    }

    const url = `/api/v1/get.user.details?${queryParam}`;

    const response = yield call(request, url, {
      method: "POST",
      credentials: "include"
    });

    if (response?.success) {
      yield put(emailApprovalActions.fetchUserApprovalSuccess(response.data));
    } else {
      yield put(
        emailApprovalActions.fetchUserApprovalFailure(
          response?.message || "Failed to fetch user"
        )
      );
    }
  } catch (error) {
    yield put(emailApprovalActions.fetchUserApprovalFailure(error.message));
  }
}

/**
 * ACTIVATE USER
 */
function* activateUserSaga(action) {
  try {
    const { id_hash, params } = action.payload;

    if (!id_hash && !params) {
      throw new Error("Missing id_hash or params (frontend guard)");
    }

    const response = yield call(request, "/api/v1/activate.user", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id_hash,
        params
      })
    });

    if (response?.success) {
      yield put(emailApprovalActions.userActionSuccess());

      yield put(
        emailApprovalActions.fetchUserApproval({
          id_hash,
          params
        })
      );
    } else {
      yield put(
        emailApprovalActions.userActionFailure(
          response?.message || "Activation failed"
        )
      );
    }
  } catch (error) {
    yield put(emailApprovalActions.userActionFailure(error.message));
  }
}

/**
 * DISABLE USER
 */
function* disableUserSaga(action) {
  try {
    const { user_id_hash, params, block_domain } = action.payload;

    if (!user_id_hash && !params) {
      throw new Error("Missing user_id_hash or params");
    }

    const response = yield call(request, "/api/v1/disable.user", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        user_id_hash,
        params,
        block_domain
      })
    });

    if (response?.success) {
      yield put(emailApprovalActions.userActionSuccess());

      yield put(
        emailApprovalActions.fetchUserApproval({
          params
        })
      );
    } else {
      yield put(
        emailApprovalActions.userActionFailure(
          response?.message || "Disable failed"
        )
      );
    }
  } catch (error) {
    yield put(emailApprovalActions.userActionFailure(error.message));
  }
}

/**
 * WATCHERS
 */
export function* EmailApprovalSaga() {
  yield takeLatest(
    emailApprovalActions.fetchUserApproval.type,
    fetchUserApprovalSaga
  );

  yield takeLatest(
    emailApprovalActions.activateUserRequest.type,
    activateUserSaga
  );

  yield takeLatest(
    emailApprovalActions.disableUserRequest.type,
    disableUserSaga
  );
}
